// extracted by mini-css-extract-plugin
export default {"overlay":"rx-z","bodyOpen":"sx-z","content":"tx-z","header":"ux-z","close":"vx-z","closeNoHeading":"wx-z"};